import {
    GameMode,
    SDKInterface,
    StartFeedConfiguration,
    StartFeedResponse,
    StopFeedResponse
} from './blue_ribbon_api_interfaces';
import {BlueRibbonExecutionMonitor} from './blue_ribbon_helpers';
import {BlueRibbonEventsDispatcher} from './event_handlers/blue_ribbon_events_dispatcher';

export class BlueRibbonFeedsController {
    constructor(private readonly _blueRibbonCoreManager: SDKInterface,
                private readonly _blueRibbonEventsDispatcher: BlueRibbonEventsDispatcher,
                private readonly _operationExecutionMonitor: BlueRibbonExecutionMonitor) {
    }
    public startAllFeeds(): Promise<StartFeedResponse> {
        return this._startGamesFeed('startAllFeeds', {
            gamesMode: GameMode.LOBBY,
            games: null
        });
    }

    public startOneJackpotFeed(jackpotId: string, gameMode: GameMode): Promise<StartFeedResponse> {
        return this._startGamesFeed('startOneJackpotFeed', {
            games: [{gameId: jackpotId}],
            gamesMode: gameMode
        });
    }

    public stopOneJackpotFeed(jackpotId: string): StopFeedResponse {
        const stopGamesFeedParams = {
            games: [{gameId: jackpotId}]
        };

        const executeStopGamesFeed = () => {
            return this._blueRibbonCoreManager.stopGamesFeed(stopGamesFeedParams);
        };

        return this._operationExecutionMonitor.executeSync({
            operationName: 'stopGamesFeed [stopOneJackpotFeed]',
            operationParams: stopGamesFeedParams
        }, executeStopGamesFeed);
    }

    private _startGamesFeed(sourceOperationName: string, startGamesFeedParams: StartFeedConfiguration): Promise<StartFeedResponse> {
        const executeStartGamesFeed = () => {
            return this._blueRibbonCoreManager.startGamesFeed(startGamesFeedParams).then(data => {
                this._blueRibbonEventsDispatcher.fireOnGamesFeedStarted(data?.startedGames?.games || []);
                return data;
            });
        };

        return this._operationExecutionMonitor.execute({
                operationName: `startGamesFeed [${sourceOperationName}]`,
                operationParams: startGamesFeedParams,
                logExecutionTimeToElastic: true
            },
            executeStartGamesFeed);
    }
}